import { /*useRef,*/ useState } from 'react';
import { Link } from 'react-router-dom';
//import { useReactToPrint } from 'react-to-print';
import { Button, message, Modal } from 'antd';
import { DeleteOutlined, DownloadOutlined, MenuOutlined, /*PrinterOutlined,*/ StarOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
//import ePub from 'epubjs';
import {
  Media,
  //MediaType,
  useGetMediaDownloadURLMutation,
  //useGetMediaURLMutation,
  useRemovePlaylistElementMutation,
  useTrackMediaDownloadMutation,
} from '../apollo/api';
import { isDeviceDisabled, useHandleDeviceDisabledError } from './DeviceDisabledError';
import MediaIcon from './MediaIcon';
import PlaylistCreationModal from './PlaylistCreationModal';

export default function MediaListItem(p: {
  productId: string;
  media: Media;
  link?: string;
  playlistId?: string;
  sortingId?: string;
  dragging?: boolean;
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: p.sortingId ?? '' });

  return (
    <div
      ref={setNodeRef}
      className={`Media-list-${p.link ? '' : 'current-'}item`}
      style={
        p.dragging
          ? { visibility: 'hidden' }
          : {
              transform: CSS.Transform.toString(transform),
              transition,
            }
      }
      {...(p.dragging ? {} : attributes)}
    >
      <MediaListItemContent dndListeners={listeners} {...p} />
    </div>
  );
}

export function PresentationalMediaListItem(p: {
  productId: string;
  media: Media;
  link?: string;
  playlistId?: string;
  sortingId?: string;
  dragging?: boolean;
}) {
  return (
    <div
      className={`Media-list-${p.link ? '' : 'current-'}item`}
      style={{
        margin: 'initial',
        width: 'initial',
      }}
    >
      <MediaListItemContent {...p} />
    </div>
  );
}

function MediaListItemContent({
  productId,
  media,
  link,
  playlistId,
  sortingId,
  dragging = false,
  dndListeners,
}: {
  productId: string;
  media: Media;
  link?: string;
  playlistId?: string;
  sortingId?: string;
  dragging?: boolean;
  dndListeners?: ReturnType<typeof useSortable>['listeners'];
}) {
  /*const [epubPrinting, setEPUBPrinting] = useState(false);
  const epubRef = useRef<HTMLDivElement>(null);

  const printEPUB = useReactToPrint({
    content: () =>
      (epubRef.current?.querySelector('iframe') as HTMLIFrameElement | null)?.contentDocument?.body ?? null,
    onAfterPrint: () => setEPUBPrinting(false),
    onPrintError: () => setEPUBPrinting(false),
  });

  const [getMediaURL] = useGetMediaURLMutation({
    onCompleted: async (data) => {
      await ePub(await (await fetch(data.mediaDownloadPresignedURL.preSignedURL)).arrayBuffer())
        .renderTo(epubRef.current!, {
          width: '100%',
          height: '100%',
          manager: 'continuous',
          flow: 'scrolled',
        })
        .display();
      printEPUB();
    },
    onError: (e) => {
      setEPUBPrinting(false);
      message.error(e.message);
    },
  });*/

  const [trackMediaDownload] = useTrackMediaDownloadMutation();

  const handleDeviceDisabledError = useHandleDeviceDisabledError();

  const [getMediaDownloadURL, { loading: mediaDownloadURLLoading }] = useGetMediaDownloadURLMutation({
    onCompleted: (data) => {
      trackMediaDownload({ variables: { productId, key: media.key } });
      window.open(data.mediaDownloadPresignedURL.preSignedURL, '_blank');
    },
    onError: (e) => {
      if (isDeviceDisabled(e)) handleDeviceDisabledError(e);
      else message.error(e.message);
    },
  });

  const [playlistCreationModalVisible, setPlaylistCreationModalVisible] = useState(false);

  const [removeFromPlaylist] = useRemovePlaylistElementMutation({
    onError: (e) => message.error(e.message),
  });

  const data = (
    <div className={`Media-list-item-data`}>
      <MediaIcon type={media.type} size={26} />
      <span dangerouslySetInnerHTML={{ __html: media.description }} className={'Media-list-item-title'} />
    </div>
  );
  return (
    <>
      {link ? (
        <Link to={link} replace className="Media-list-item-link">
          {data}
        </Link>
      ) : (
        data
      )}
      {/*media.type === MediaType.EPUB && (
        <Button
          type="link"
          icon={<PrinterOutlined />}
          loading={epubPrinting}
          onClick={() => {
            setEPUBPrinting(true);
            getMediaURL({ variables: { productId, key: media.key } });
          }}
          className="Action-button"
        />
      )*/}
      {/*epubPrinting && (
        <div
          ref={epubRef}
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
            opacity: 0,
          }}
        />
      )*/}
      {media.downloadable && (
        <Button
          type="link"
          icon={<DownloadOutlined />}
          loading={mediaDownloadURLLoading}
          onClick={() => getMediaDownloadURL({ variables: { productId, key: media.key } })}
          className="Action-button"
        />
      )}
      <Button
        type="link"
        icon={<StarOutlined />}
        onClick={() => setPlaylistCreationModalVisible(true)}
        className="Action-button"
      />
      <PlaylistCreationModal
        productId={productId}
        mediaKey={media.key}
        ignoredPlaylistId={playlistId}
        visible={playlistCreationModalVisible}
        closeFn={() => setPlaylistCreationModalVisible(false)}
      />
      {playlistId && (
        <>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => {
              Modal.confirm({
                title: 'Rimuovi da playlist',
                content: 'Rimuovere questo elemento dalla playlist?',
                cancelText: 'Annulla',
                okText: 'Continua',
                onOk: () =>
                  removeFromPlaylist({
                    variables: { playlistId, productId, mediaKey: media.key },
                  }),
              });
            }}
            className="Action-button"
          />
          <Button
            type="link"
            icon={<MenuOutlined />}
            className="Action-button"
            style={{ cursor: dragging ? 'grabbing' : 'grab' }}
            {...(sortingId ? dndListeners : {})}
          />
        </>
      )}
    </>
  );
}
